// import React from "react";
// import { CheckCircle } from "lucide-react"; 
// import { useNavigate } from "react-router-dom";

// function PaymentSuccess() {
//   const navigate = useNavigate();
//   console.log('ocalStorage.getItem(AccidentVehicleCode)', localStorage.getItem('AccidentVehicleCode'))
//   return (
//     <div className="font-satoshi bg-green-50 min-h-screen flex items-center justify-center px-4 font-satoshi">
//       <div className="bg-white p-8 md:p-10 rounded-xl shadow-xl max-w-md w-full text-center">
//         <div className="text-green-600 text-4xl mb-4 flex justify-center">
//           <CheckCircle size={48} />
//         </div>
//         <h1 className="text-2xl font-bold text-green-700 mb-2">Payment Successful</h1>
//         <p className="text-gray-700 text-base mb-6">
//           Thank you for your payment. Your transaction has been completed successfully.
//         </p>
//         <button
//           onClick={() => {
//             navigate('/driver-status-tracking', {
//               state: {
//                 accidentVehicleCode: localStorage.getItem('AccidentVehicleCode'),
//               },
//             });
//           }}
//           className="inline-block bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-6 rounded-md transition duration-200"
//         >
//           Continue
//         </button>
//       </div>
//     </div>
//   );
// }

// export default PaymentSuccess;


import React, {useState, useEffect} from "react";
import { CheckCircle } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

function PaymentSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderId = queryParams.get("orderId");
  const amount = queryParams.get("amount");
    const [secondsLeft, setSecondsLeft] = useState(5);

      useEffect(() => {
    const timer = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev === 1) {
          clearInterval(timer);
             const keepKeys = [
            "iconify-version",
            "iconify-count",
            "token",
            "userId",
            "loginId",
            "loginTime",
            "userRole",
            "fromLogin",
            "justLoggedIn",
            "gps_location",
            "currentService"
        ];

        Object.keys(localStorage).forEach((key) => {
            if (!keepKeys.includes(key)) {
                localStorage.removeItem(key);
            }
        });
          navigate("/customer-home-page");
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer); // Cleanup
  }, [navigate]);

  return (
    <div className="font-satoshi bg-green-50 min-h-screen flex items-center justify-center px-4">
      <div className="bg-white p-8 md:p-10 rounded-xl shadow-xl max-w-md w-full text-center">
        <div className="text-green-600 text-4xl mb-4 flex justify-center">
          <CheckCircle size={48} />
        </div>
        <h1 className="text-2xl font-bold text-green-700 mb-2">Payment Successful</h1>
        <p className="text-gray-700 text-base mb-2">
          Thank you for your payment. Your transaction has been completed successfully.
        </p>

        {/* Order info */}
        {orderId && (
          <p className="text-gray-600 text-sm mb-1">
            <strong>Order ID:</strong> {orderId}
          </p>
        )}
        {amount && (
          <p className="text-gray-600 text-sm mb-4">
            <strong>Amount Paid:</strong> ₹{amount}
          </p>
        )}

        {/* Countdown Message */}
        <p className="text-sm text-gray-700 font-semibold">
          Redirecting you in <span className="text-green-700 font-bold">{secondsLeft}</span> second{secondsLeft !== 1 ? "s" : ""}...
        </p>
      </div>
    </div>
  );
}

export default PaymentSuccess;
 